import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import TranslationEN from "./locale/en.json";
import TranslationAR from "./locale/ar.json";
import TranslationFR from "./locale/fr.json";
import TranslationRU from "./locale/ru.json";
import TranslationHI from "./locale/hi.json";
import TranslationCH from "./locale/ch.json";
import TranslationDE from "./locale/de.json";
import TranslationKO from "./locale/ko.json";
import TranslationSP from "./locale/es.json";
import TranslationCHS from "./locale/CH-HANS.json";
import TranslationCHT from "./locale/ch-hant.json";
import TranslationJAPAN from "./locale/jp.json";
import TranslationPH from "./locale/fil.json";
import TranslationTH from "./locale/thai.json";
import TranslationPT from "./locale/pt.json";
import TranslationNL from "./locale/nl.json";
import TranslationZHS from "./locale/zh-Hans.json";

const langu = sessionStorage.getItem("lang") || "EN";

const resources = {
  EN: {
    translation: TranslationEN,
  },
  AR: {
    translation: TranslationAR,
  },
  FR: {
    translation: TranslationFR,
  },
  RU: {
    translation: TranslationRU,
  },
  HI: {
    translation: TranslationHI,
  },
  CH: {
    translation: TranslationCH,
  },
  DE: {
    translation: TranslationDE,
  },
  KO: {
    translation: TranslationKO,
  },
  ES: {
    translation: TranslationSP,
  },
  "CH-Hant": {
    translation: TranslationCHS,
  },
  "CH-Hans": {
    translation: TranslationCHT,
  },
  JA: {
    translation: TranslationJAPAN,
  },
  PH: {
    translation: TranslationPH,
  },
  TH: {
    translation: TranslationTH,
  },
  PT: {
    translation: TranslationPT,
  },
  NL: {
    translation: TranslationNL,
  },
  "zh-Hans": {
    translation: TranslationZHS,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: langu,
    fallbackLng: langu,
    debug: false,
    detection: {
      order: ["sessionStorage"],
      lookupSessionStorage: "lang",
      caches: ["sessionStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
